// extracted by mini-css-extract-plugin
export default {"geoRestrictionCheckbox":"doteL"};